import type { Feature } from '@/shared/registry'

/** Every feature's `index.ts`, found at build time, so listing a feature below takes one line. */
const indexes = import.meta.glob<Feature>('/src/features/*/index.ts', {
  eager: true,
  import: 'feature',
})

function feature(folder: string): Feature {
  const found = indexes[`/src/features/${folder}/index.ts`]
  if (found === undefined) {
    throw new Error(`There is no src/features/${folder}/index.ts exporting a feature.`)
  }
  return found
}

/**
 * The features, one line each. `App` builds the routes, nav, Admin Home and slots from this
 * list, in this order: nav items, Admin Home sections and slot contributions follow it.
 */
export const features: readonly Feature[] = [
  feature('auth'),
  feature('home'),
  feature('diagnostics'),
  feature('admin-home'),
  feature('access-control'),
  feature('site-management'),
  feature('catalog'),
  feature('learner-history'),
  feature('classes'),
  feature('entitlements'),
  feature('launch'),
  feature('channels'),
  feature('notifications'),
  feature('credentials'),
  feature('not-found'),
  feature('ui-gallery'),
]
